import { render, staticRenderFns } from "./addContrast.vue?vue&type=template&id=0f9cc491&scoped=true"
import script from "./addContrast.vue?vue&type=script&lang=js"
export * from "./addContrast.vue?vue&type=script&lang=js"
import style0 from "./addContrast.vue?vue&type=style&index=0&id=0f9cc491&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9cc491",
  null
  
)

export default component.exports